import { render, staticRenderFns } from "./appointmentManagement.vue?vue&type=template&id=f0932320&scoped=true&"
import script from "./appointmentManagement.vue?vue&type=script&lang=js&"
export * from "./appointmentManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0932320",
  null
  
)

export default component.exports